module.exports = __webpack_public_path__ + "img/proyectos4.2ab6341f.png";